import React from 'react';
import ResetPassword from '../components/accounts/reset_password/reset_password';

export default props => (
  <ResetPassword {...props} />
);
